export default [
  {
    value: 'FIXO',
    text: 'Fixo',
  },
  {
    value: 'PERCENTUAL',
    text: 'Percentual',
  },
];
